import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FileHeart02 = function FileHeart02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20 10V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12m.5-11H8m1 4H8m8-8H8m8.9973 7.8306c-.7998-.909-2.1334-1.1535-3.1354-.3212s-1.1431 2.2241-.3562 3.2085C14.2926 18.7024 16.9973 21 16.9973 21s2.7046-2.2976 3.4915-3.2821.6631-2.3848-.3562-3.2085c-1.0192-.8236-2.3356-.5878-3.1353.3212"
    })
  }));
};
export default FileHeart02;